import React, { Component } from "react";
import { Switch, Route, Link, BrowserRouter as Router } from "react-router-dom";
import axios from 'axios';
import jwt_decode from 'jwt-decode';

import AddProduct from './components/AddProduct';
import Cart from './components/Cart';
import Login from './components/Login';
import ProductList from './components/ProductList';

import Context from "./Context";

export default class App extends Component {
  constructor(props) {
    super(props);
      this.clearCart();
    this.state = {
      user: null,
      cart: {},
      products: []
    };
    this.routerRef = React.createRef();
  }

  async componentDidMount() {
    document.title = "Crown Highs"
    if (!localStorage.getItem("user")) {
      this.routerRef.current.history.replace("/login");
      return;
    }
      
    let user = localStorage.getItem("user");
    let cart = localStorage.getItem("cart");

    const products = await axios.get('https://script.google.com/macros/s/AKfycbz_JZaq_BILr2xHUsvO2x1J6WfSROUADYt4YWwEDOZUVXle000/exec');
      
    console.log(products)
    user = user ? JSON.parse(user) : null;
    cart = cart? JSON.parse(cart) : {};
      
    this.setState({ user,  products: products.data, cart });
      
    const deploymentState = await axios.get('https://script.google.com/macros/s/AKfycbxCho9tY12mUKJ3t756BheCrTTCstxpsvImJoGVQmv8rvEfVNMD/exec');
     
    console.log('deploy: ' + JSON.stringify(deploymentState))
      
    if(deploymentState.data == false){
        this.setState({ user: null, products:null });
        localStorage.removeItem("user");
         window.location.reload(false);

    }
  }

  login = async (password) => {
      
      if(password = "hello"){
         localStorage.setItem("user", true);
         return true
      }
      return false
  }

  logout = e => {
    e.preventDefault();
    this.setState({ user: null });
    localStorage.removeItem("user");
     window.location.reload(false);

  };

  addProduct = (product, callback) => {
    let products = this.state.products.slice();
    products.push(product);
    this.setState({ products }, () => callback && callback());
  };


  addToCart = cartItem => {
    if (cartItem.amount<1){
        return 
    }
    let cart = this.state.cart;
    if (cart[cartItem.id]) {
      cart[cartItem.id].amount += cartItem.amount;
    } else {
      cart[cartItem.id] = cartItem;
    }
//    if (cart[cartItem.id].amount > cart[cartItem.id].product.stock) {
//      cart[cartItem.id].amount = cart[cartItem.id].product.stock;
//    }
    console.log("adding to card: " + JSON.stringify(cartItem))
    localStorage.setItem("cart", JSON.stringify(cart));
    this.setState({ cart });
  };

  removeFromCart = cartItemId => {
    let cart = this.state.cart;
    delete cart[cartItemId];
    localStorage.setItem("cart", JSON.stringify(cart));
    this.setState({ cart });
  };

  clearCart = () => {
    let cart = {};
    localStorage.removeItem("cart");
    this.setState({ cart });
  };

    navigateHome = () => {
        if(this.state.user){
             this.routerRef.current.history.push("/")
        }
    };

    navigateLogin = () => {
        localStorage.removeItem("user");

        window.location.reload(false);

        this.routerRef.current.history.push("/login")
        
    };

  checkout = () => {

    const cart = this.state.cart;

    const products = this.state.products.map(p => {
      if (cart[p.name]) {
        p.stock = p.stock - cart[p.name].amount;

//        axios.put(
//          `http://localhost:3001/products/${p.id}`,
//          { ...p },
//        )
      }
      return p;
    });

    this.setState({ products });
    this.clearCart();
  };

  render() {
    return (
      <Context.Provider
        value={{
          ...this.state,
          removeFromCart: this.removeFromCart,
          addToCart: this.addToCart,
          login: this.login,
          addProduct: this.addProduct,
          clearCart: this.clearCart,
          checkout: this.checkout, 
          logout: this.navigateLogin
        }}
      >
        <Router ref={this.routerRef}>
        <div className="App">
          <nav
            className="navbar container"
            role="navigation"
            aria-label="main navigation"
          >
            <div className="navbar-brand">
              <b className="navbar-item is-size-4 "  onClick={this.navigateHome} >CrownHighs</b>
              
            {this.state.user ? (<label
                role="button"
                className="navbar-burger burger"
                aria-label="menu"
                aria-expanded="false"
                data-target="navbarBasicExample"
                onClick={e => {
                  e.preventDefault();
                  this.setState({ showMenu: !this.state.showMenu });
                }}
              >
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </label>): (<></>)}
            </div>
              <div className={`navbar-menu ${
                  this.state.showMenu ? "is-active" : ""
                }`}>
                <Link to="/products" className="navbar-item">
                  Products
                </Link>
                {this.state.user && this.state.user.accessLevel < 1 && (
                  <Link to="/add-product" className="navbar-item">
                    Add Product
                  </Link>
                )}
                <Link to="/cart" className="navbar-item">
                  Cart
                  <span
                    className="tag is-primary"
                    style={{ marginLeft: "5px" }}
                  >
                    { Object.keys(this.state.cart).length }
                  </span>
                </Link>
                {!this.state.user ? (
                  <Link to="/login" className="navbar-item">
                    Login
                  </Link>
                ) : (
                  <Link to="/" onClick={this.logout} className="navbar-item">
                    Logout
                  </Link>
                )}
              </div>
            </nav>
            <Switch>
              <Route exact path="/" component={ProductList} />
              <Route exact path="/login" component={Login}  />
              <Route exact path="/cart" component={Cart}/>
              <Route exact path="/add-product" component={AddProduct} />
              <Route exact path="/products" component={ProductList} />
            </Switch>
          </div>
        </Router>
      </Context.Provider>
    );
  }
}
